var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.owners_association)?_c('NewsDetail',{attrs:{"owners_association":_vm.owners_association,"news":_vm.news,"img-no":_vm.imgNo,"is-loading":_vm.isLoading,"no_news":_vm.no_news}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }